// Registers the /crew-scoped service worker + injects the PWA <meta> tags
// only while a worker is actually inside the worker portal. Anything scoped
// globally in index.html would let admins/VAs install a "worker app" from
// the wrong route, so we own it here and idempotently keep the tags in sync.

const MANIFEST_ID = "hcob-worker-manifest";
const THEME_ID = "hcob-worker-theme";
const APPLE_ICON_ID = "hcob-worker-apple-icon";
const APPLE_STATUS_ID = "hcob-worker-apple-status";
const APPLE_CAPABLE_ID = "hcob-worker-apple-capable";
const APPLE_TITLE_ID = "hcob-worker-apple-title";

function upsertLink(id, attrs) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("link");
    el.id = id;
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

function upsertMeta(id, attrs) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("meta");
    el.id = id;
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

function injectPwaMeta() {
  upsertLink(MANIFEST_ID, { rel: "manifest", href: "/worker-manifest.json" });
  upsertMeta(THEME_ID, { name: "theme-color", content: "#030712" });
  // iOS Safari — doesn't read the manifest for icon/name, needs the classic
  // apple-* meta family to render a proper home-screen icon + splash.
  upsertLink(APPLE_ICON_ID, { rel: "apple-touch-icon", href: "/worker-apple-touch.png" });
  upsertMeta(APPLE_STATUS_ID, {
    name: "apple-mobile-web-app-status-bar-style",
    content: "black-translucent",
  });
  upsertMeta(APPLE_CAPABLE_ID, {
    name: "apple-mobile-web-app-capable",
    content: "yes",
  });
  upsertMeta(APPLE_TITLE_ID, {
    name: "apple-mobile-web-app-title",
    content: "HCOB Worker",
  });
}

let registered = false;

export function registerWorkerServiceWorker() {
  injectPwaMeta();
  if (registered) return;
  registered = true;

  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Only register in a secure context (HTTPS or localhost) — CRA dev on
  // localhost qualifies, so this works in Preview + Prod but no-ops on
  // insecure networks.
  if (!window.isSecureContext) return;

  const doRegister = () => {
    navigator.serviceWorker
      .register("/worker-sw.js", { scope: "/crew" })
      .then((reg) => {
        // Auto-activate a new SW as soon as it's installed so workers don't
        // have to close all tabs to get the latest deploy.
        if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
        reg.addEventListener("updatefound", () => {
          const w = reg.installing;
          if (!w) return;
          w.addEventListener("statechange", () => {
            if (w.state === "installed" && navigator.serviceWorker.controller) {
              w.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {
        // SW is a progressive enhancement — network failure is fine.
      });
  };

  if (document.readyState === "complete") {
    doRegister();
  } else {
    window.addEventListener("load", doRegister, { once: true });
  }
}
